// Achievement definitions for Valentine Farm Game

export interface Achievement {
    id: string;
    title: string;
    description: string;
    icon: string;
    condition: (answers: Record<string, string>) => boolean;
}

export const ACHIEVEMENTS: Achievement[] = [
    {
        id: 'soft_life',
        title: 'Soft Life Activated',
        description: 'Chose spa treatment AND dessert',
        icon: '🧖✨',
        condition: (answers) =>
            (answers.spaAddon === 'massage' || answers.spaAddon === 'facial') &&
            !!answers.dessert &&
            answers.dessert !== 'no',
    },
    {
        id: 'outdoor_babe',
        title: 'Outdoor Babe',
        description: 'Chose outdoors vibe AND beach activity',
        icon: '🌊🌴',
        condition: (answers) =>
            answers.vibe === 'outdoors' && answers.activity === 'beach',
    },
    {
        id: 'memory_keeper',
        title: 'Memory Keeper',
        description: 'Wants ALL the photos',
        icon: '📸💕',
        condition: (answers) => answers.photoMode === 'take pics',
    },
    {
        id: 'no_stress_queen',
        title: 'No Stress Queen',
        description: 'Day-only stay AND no surprises',
        icon: '👑😌',
        condition: (answers) =>
            answers.stayType === 'day-only' && answers.surpriseTolerance === 'none',
    },
    {
        id: 'foodie',
        title: 'Foodie',
        description: 'Completed food AND dessert choices',
        icon: '🍽️🍰',
        condition: (answers) =>
            !!answers.food && !!answers.dessert,
    },
    {
        id: 'city_builder',
        title: 'City Builder',
        description: 'Placed 6+ buildings/props',
        icon: '🏗️🏘️',
        condition: (answers) => {
            let count = 0;
            if (answers.stayType) count++;
            if (answers.vibe === 'outdoors' || answers.vibe === 'mix') count++;
            if (answers.food) count++;
            if (answers.activity) count++;
            if (answers.location === 'travel') count++;
            if (answers.beautyNails === 'yes' || answers.beautyLashes === 'yes') count++;
            if (answers.spaAddon === 'massage' || answers.spaAddon === 'facial') count++;
            if (answers.dessert && answers.dessert !== 'no') count++;
            return count >= 6;
        },
    },
    {
        id: 'travel_energy',
        title: 'Travel Energy',
        description: 'Chose to travel AND picked a destination',
        icon: '✈️🧳',
        condition: (answers) =>
            answers.location === 'travel' && !!answers.travelPlace,
    },
    {
        id: 'beauty_run',
        title: 'Beauty Run',
        description: 'Getting nails OR lashes done',
        icon: '💅✨',
        condition: (answers) =>
            answers.beautyNails === 'yes' || answers.beautyLashes === 'yes',
    },
    {
        id: 'full_glam',
        title: 'Full Glam',
        description: 'Getting BOTH nails AND lashes',
        icon: '💅👁️💖',
        condition: (answers) =>
            answers.beautyNails === 'yes' && answers.beautyLashes === 'yes',
    },
    {
        id: 'romantic_soul',
        title: 'Romantic Soul',
        description: 'Chose romantic/calm season with dressy outfit',
        icon: '💕👗',
        condition: (answers) =>
            answers.season === 'romantic/calm' && answers.outfitTheme === 'dressy',
    },
    {
        id: 'matching_couple',
        title: 'Matching Couple Goals',
        description: 'Chose matching colors outfit',
        icon: '💑💜',
        condition: (answers) => answers.outfitTheme === 'matching colors',
    },
    {
        id: 'luxury_tier',
        title: 'Luxury Tier',
        description: 'Chose hotel AND continental or sushi',
        icon: '🏨✨',
        condition: (answers) =>
            answers.stayType === 'hotel' &&
            (answers.food === 'continental' || answers.food === 'sushi'),
    },
];

export function getUnlockedAchievements(
    answers: Record<string, string>,
    previouslyUnlocked: string[] = []
): Achievement[] {
    return ACHIEVEMENTS.filter(
        (a) => a.condition(answers) && !previouslyUnlocked.includes(a.id)
    );
}

export function getAllUnlockedAchievements(answers: Record<string, string>): Achievement[] {
    return ACHIEVEMENTS.filter((a) => a.condition(answers));
}

export function checkNewAchievements(
    answers: Record<string, string>,
    previouslyUnlocked: string[]
): Achievement[] {
    return getUnlockedAchievements(answers, previouslyUnlocked);
}
